import task from "@commons/task";

var iframe = $("#carsharing-map");
$(iframe).attr("src", $(iframe).data("src"));

var modal = $("#rental-login");

window.CSAppWeb = {
    logout: function () {
        $.get(task("Account.logOut"), function (data) {
            window.location.href = task("User");
        });
    },
    rentLogin: function (assetId, assetType) { // Es CSAppWeb.rentLogin('RM001TR');        
        if (!$(modal).length) {// Es login esterno
            window.location.href = task("User");
            return;
        }

        $("#map-login-type").val("reservation");
        $("#request-asset-id").val(assetId);
        $("#request-asset-type").val(assetType);
        $(modal).modal('show');
    },
    booking: function (parkingLotId, assetType, notLogged) {
        if (!notLogged || !$(modal).length) {
            window.location.href = task("Booking", "parkingLotId=" + parkingLotId + "&assetType=" + assetType);
        } else {
            $("#map-login-type").val("booking");
            $("#request-parking-lot-Id").val(parkingLotId);
            $("#request-asset-type").val(assetType);
            $(modal).modal('show');
        }
    },
    getClientColors: function () {
        return {
            "primaryColor": $("#jsPrimaryColor").css('color'),
            "secondaryColor": $("#jsSecondaryColor").css('color')
        };
    },
    getUrlOrigin: function () {
        return window.cpAppSet.baseApiUrl;
    }
};

/*----Login rental-----*/
(function ($) {

    if (!$(modal).length) {// Es login esterno
        return;
    }

    var form = $("form", modal);
    var userMsg = $(".user-msg", modal);
    var btn = $("button", form);

    $(form).submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();

        $(btn).addClass("spin").attr("aria-busy", "true");
        $(userMsg).removeClass("alert-warning").attr('aria-hidden', 'true').html("").hide();

        $.post(task("User.Login"), data, function (response) {
            if (response.success) {
                $(form)[0].reset();
                if (response.goTo) {
                    $(location).attr('href', response.goTo);
                } else {
                    location.reload();
                }
            } else {
                $(userMsg).addClass("alert-warning").html(response.message).fadeIn().attr('aria-hidden', 'false');
                $(btn).removeClass("spin").attr("aria-busy", "false");
            }

        }, 'json').fail(function (xhr, status, error) {
            $(btn).removeClass("spin").attr("aria-busy", "false");
            alert(error);
        });

    });

    $(modal).on('hidden.bs.modal', function () {
        //alert("Close");
        $(form)[0].reset();
        $(".reset-field", form).val("");
    });

})(jQuery);
